module.exports =  {
  VERSION_MISMATCH: "version_mismatch",
  CODING_VERSION_MISMATCH: "coding_version_mismatch",
  AI_CODING_IN_PROGRESS: "ai_coding_in_progress"
}
